<vl-justup-page class="page-flex-column w100" type="large" [new]="true">
  @if (editable()) {
    <div class="justup-page-title flex-row">
        <span class="headline on-background">
          {{ dashboard()?.denomination }}
        </span>
      <div class="ml-auto flex-row gap-8">
        <span [matTooltip]="'dashboard_ui.actualiser' | trans">
          <vl-big-button
            type="rounded"
            color="secondary"
            (action)="onRefresh()"
            icon="refresh"
            [loading]="refreshing()"
            [text]="''"
          />
        </span>
        <vl-big-button color="primary" (action)="openSettings()" icon="settings" [text]="'dashboard_ui.parametres' | trans"/>
      </div>
    </div>
  }

  <div class="justup-page-content">
    @if (dashboard()) {
      <div class="flex-row dashboard-container" [ngClass]="{'p-8': !this.editable()}" #container>
        <vl-dashboard [containerElement]="containerElement()" [rowHeight]="rowHeight()"/>
      </div>
    }
  </div>
</vl-justup-page>
